import { SarsModel } from "../../domain/SarsModel";

export const defaultAffectedQualification = { id: null };

export const defaultValues: Partial<SarsModel> = {
  id: "",
  createdByUpn: "",
  createdByDisplayName: "",
  modifiedByUpn: "",
  modifiedByDisplayName: "",
  referenceNumber: "",
  caseTitle: "",
  status: 0,
  dateReceived: "",
  dateResponseDue: "",
  caseLeadUPN: null,
  caseLeadDisplayName: null,
  identificationRequired: 0,
  dateIdRequested: null,
  firstName: "",
  middleName: null,
  lastName: "",
  email: null, 
  telephone: null,
  line1: null,
  line2: null,
  line3: null,
  line4: null,
  postcode: null,
  countryId: 0,
  requestDetail: "",
  caseSummary: null,
  sourceId: null,
  categoryId: null,
};
